import NotificarService from '@/services/notificar.service'

export default {
  namespaced: true,
  state: {
    status: null,
    loading: false,
    error: null
  },
  mutations: {
    setLoading: (state, loading) => state.loading = loading,
    setError: (state, error) => state.error = error,
    setStatus: (state, status) => state.status = status,
  },
  actions: {
    async ['enviar']({ commit },
      { codigo, tipo }
    ) {
      try {
        commit('setLoading', true)
        const data = await NotificarService.notificar(codigo, tipo)
        commit('setStatus', data)
      } catch (error) {
        commit('setError', error)
      } finally {
        commit('setLoading', false)
      }
    },
  },
  getters: {
    getLoading: state => state.loading,
    getError: state => state.error,
    getStatus: state => state.status,
  }
}
